import React from 'react';
import { gql } from '@apollo/client';
import { Constrain } from '@moda/om';
import {
  CarouselPumoModuleGridFragment,
  CarouselPumoModuleGridFragment_cells_Look as LookCell
} from '../../generated/types/CarouselPumoModuleGridFragment';
import { CarouselCell, CAROUSEL_CELL_FRAGMENT } from '../Grid';
import { LazyGrid } from '../Grid';
import { LookCellsGrid } from '../LookCellsGrid';

export const CAROUSEL_PUMO_MODULE_GRID_FRAGMENT = gql`
  fragment CarouselPumoModuleGridFragment on CarouselPumoModule {
    cells {
      ...CarouselCellFragment
    }
  }
  ${CAROUSEL_CELL_FRAGMENT}
`;

interface Props {
  carouselPumoModuleGrid: CarouselPumoModuleGridFragment;
  onClick?: (event: Event | React.MouseEvent) => void;
}

export const CarouselPumoModuleGrid: React.FC<Props> = ({ carouselPumoModuleGrid, onClick }) => {
  if (carouselPumoModuleGrid.cells.every(cell => cell.__typename === 'Look')) {
    return <LookCellsGrid looks={carouselPumoModuleGrid.cells as LookCell[]} onClick={onClick} />;
  }

  return (
    <Constrain>
      <LazyGrid onClick={onClick}>
        {carouselPumoModuleGrid.cells.map((cell, index) => (
          <CarouselCell key={index} carouselCell={cell} />
        ))}
      </LazyGrid>
    </Constrain>
  );
};
